// extracted by mini-css-extract-plugin
module.exports = {"pro-blog-container":"ProBlogPostContent_pro-blog-container__VGxTb","wrapper":"ProBlogPostContent_wrapper__UDHLV"};